// src/components/PageBackground.jsx
import React from "react";

const PageBackground = ({
  image,
  children,
  boxed = true,
  boxedWidth = "max-w-7xl", // max-w-3xl for bigger side gutters
  overlayClass = "bg-white/85 backdrop-blur",
  pad = "p-6",
  margin = "my-8",
  className,
  edgeToEdge = false,
}) => {
  const containerClasses = [
    "w-full",
    boxed ? `${boxedWidth} mx-auto` : "",
    // When edgeToEdge is true, don't add any padding to container
    edgeToEdge ? "" : (className !== undefined ? className : "px-4"),
  ]
    .filter(Boolean)
    .join(" ");
    
  const contentClasses = edgeToEdge 
    ? `${overlayClass}` 
    : `rounded-2xl shadow-sm ${overlayClass} ${pad} ${margin}`;
    
  return (
    <div
      className="bg-center bg-cover bg-fixed"
      style={{
        backgroundImage: `url(${image})`,
        // Account for mobile tab bar (48px + padding) and header
        minHeight: "calc(100vh - 80px)", // Reduced from 128px to 80px for mobile
      }}
    >
      <div className={containerClasses}>
        <div className={contentClasses}>
          {children}
        </div>
      </div>
      {/* Add bottom padding for mobile tab bar */}
      <div className="md:hidden h-16" />
    </div>
  );
};

export default PageBackground;
